/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom';
import { Button, ModalGeneric } from 'ypf-pas-general-ui-components';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { checkRol, checkUserPermission } from '../../../../../security';
import {
  proveedorNotificador,
  proveedorAdministrador,
  notificador,
  solicitante,
  aprobador
} from '../../../../../security/constantsRols';
import { statusEnum } from '../../../../../utils/dataStatus';
import {
  putCancel,
  patchResponseProvider,
  patchReschedulingDates,
  putFinalizeService
} from '../../../../../services/serviceRequest';
import useToast from '../../../../../hooks/useToast';
import RejectionForm from '../../../../../components/RejectionForm/RejectionForm';
import ReschedulingForm from '../../../../../components/ReschedulingForm/ReschedulingForm';
import { menuActions } from '../../../../../constants/constants';
import {
  putCancelMonthly,
  putFinalizeServiceMonthly
} from '../../../../../services/monthlyServiceRequest';
import '../TabsDetail.scss';
import { FinalizarSDS } from '../../../../../security/constantsPermissions';

const getButtonsForNotificador = (idStatus) => {
  if (
    (checkRol(notificador) && idStatus === statusEnum.asignada) ||
    idStatus === statusEnum.finalizada ||
    (idStatus === statusEnum.asignada &&
      (checkRol(proveedorNotificador) || checkRol(proveedorAdministrador)))
  ) {
    return [menuActions.salir];
  }

  return null;
};

const getButtonsForSolicitante = (idStatus, isMonthly) => {
  if (
    checkRol(solicitante) &&
    (idStatus === statusEnum.enviada || idStatus === statusEnum.asignada)
  ) {
    if (isMonthly) {
      return [menuActions.salir, menuActions.cancelar];
    }

    return [menuActions.salir, menuActions.reprogramar, menuActions.cancelar];
  }

  return null;
};

const getButtonsForProveedorAdministrador = (idStatus, aceptado) => {
  if (checkRol(proveedorAdministrador) && idStatus === statusEnum.enviada) {
    if (aceptado === null) {
      return [menuActions.salir, menuActions.rechazar, menuActions.aceptarSolicitud];
    }
    if (aceptado) {
      return [menuActions.salir, menuActions.cancelarAceptacion];
    }
  }

  return null;
};

const getButtonsForEnEjecucion = (idStatus) => {
  if (idStatus === statusEnum.enEjecucion && checkUserPermission([FinalizarSDS])) {
    return [menuActions.salir, menuActions.finalizar];
  }

  return null;
};

const selectButtons = (idStatus, aceptado, isMonthly) => {
  const buttonsForNotificador = getButtonsForNotificador(idStatus);

  if (buttonsForNotificador) return buttonsForNotificador;

  const buttonsForSolicitante = getButtonsForSolicitante(idStatus, isMonthly);

  if (buttonsForSolicitante) return buttonsForSolicitante;

  const buttonsForEnEjecucion = getButtonsForEnEjecucion(idStatus);

  if (buttonsForEnEjecucion) return buttonsForEnEjecucion;

  const buttonsForProveedorAdministrador = getButtonsForProveedorAdministrador(idStatus, aceptado);

  if (buttonsForProveedorAdministrador) return buttonsForProveedorAdministrador;

  return [menuActions.salir];
};

const activeButtons = (buttons, selected) => {
  const keys = Object.keys(buttons);
  const newButtons = {};

  keys.forEach((key) => {
    newButtons[key] = {
      ...buttons[key],
      active: selected.some((select) => select === buttons[key].label)
    };
  });

  return newButtons;
};

const initialModal = {
  cancelar: false,
  reprogramar: false,
  rechazar: false,
  cancelarAceptacion: false,
  aceptarSolicitud: false,
  finalizar: false
};

const validationSchema = Yup.object({
  dates: Yup.object({
    realizationDate: Yup.string().required('Seleccione una fecha probable'),
    responseDate: Yup.string().required('Seleccione una fecha de necesidad')
  }),
  classification: Yup.number().required('Debe seleccionar una clasificación'),
  reason: Yup.string().required('Debe describir el motivo')
});

const ButtonTab = ({
  idStatus,
  accepted,
  sdsNumber,
  dates,
  sdsName,
  showFinalizeButton,
  isMonthly
}) => {
  const history = useHistory();
  const { id } = useParams();
  const { setNewToast } = useToast();
  const { values, setFieldValue, setFieldTouched, touched, errors, resetForm } = useFormik({
    initialValues: {
      dates,
      classification: 0,
      reason: ''
    },
    validationSchema
  });
  const [showModal, setShowModal] = useState(initialModal);
  const [disableButton, setDisableButton] = useState(false);
  const [buttons, setButtons] = useState({
    salir: {
      active: false,
      label: menuActions.salir
    },
    reprogramar: {
      active: false,
      label: menuActions.reprogramar
    },
    aceptarSolicitud: {
      active: false,
      label: menuActions.aceptarSolicitud
    },
    cancelarAceptacion: {
      active: false,
      label: menuActions.cancelarAceptacion
    },
    rechazar: {
      active: false,
      label: menuActions.rechazar
    },
    finalizar: {
      active: false,
      label: menuActions.finalizar
    },
    cancelar: {
      active: false,
      label: menuActions.cancelar
    }
  });

  const activeModal = (modal) => {
    const keys = Object.keys(showModal);
    const newShowModal = {};

    keys.forEach((key) => {
      newShowModal[key] = modal === key;
    });
    setShowModal(newShowModal);
  };
  const hideModal = () => {
    setShowModal(initialModal);
    resetForm();
  };

  useEffect(() => {
    const selectedButtons = selectButtons(idStatus, accepted, isMonthly);

    setButtons(activeButtons(buttons, selectedButtons));
  }, [idStatus]);

  return (
    <>
      {buttons.salir.active && (
        <Button
          key={buttons.salir.label}
          label={buttons.salir.label}
          onClick={() => {
            sessionStorage.removeItem('equipoSeleccionado');
            if (checkRol(aprobador)) {
              history.push('/approver');
            } else {
              history.push('/');
            }
          }}
          type="button"
          variant="primary"
          widthButton="70px"
        />
      )}
      {buttons.reprogramar.active && (
        <Button
          key={buttons.reprogramar.label}
          label={buttons.reprogramar.label}
          onClick={() => activeModal('reprogramar')}
          type="button"
          variant="outline-primary"
          widthButton="120px"
        />
      )}
      {buttons.cancelar.active && (
        <Button
          key={buttons.cancelar.label}
          label={buttons.cancelar.label}
          onClick={() => {
            activeModal('cancelar');
          }}
          type="button"
          variant="outline-danger"
          widthButton="140px"
        />
      )}
      {buttons.rechazar.active && (
        <Button
          key={buttons.rechazar.label}
          label={buttons.rechazar.label}
          onClick={() => activeModal('rechazar')}
          type="button"
          variant="danger"
          widthButton="120px"
        />
      )}
      {buttons.aceptarSolicitud.active && (
        <Button
          key={buttons.aceptarSolicitud.label}
          label={buttons.aceptarSolicitud.label}
          onClick={() => {
            activeModal('aceptarSolicitud');
          }}
          type="button"
          variant="success"
          widthButton="140px"
        />
      )}
      {buttons.cancelarAceptacion.active && (
        <Button
          key={buttons.cancelarAceptacion.label}
          label={buttons.cancelarAceptacion.label}
          onClick={() => activeModal('cancelarAceptacion')}
          type="button"
          variant="outline-danger"
          widthButton="140px"
        />
      )}
      {buttons.finalizar.active && showFinalizeButton && (
        <Button
          key={buttons.finalizar.label}
          label={buttons.finalizar.label}
          onClick={() => activeModal('finalizar')}
          type="button"
          variant="outline-danger"
          widthButton="140px"
        />
      )}

      <ModalGeneric
        backdrop
        infoModal
        onHide={hideModal}
        primaryAction={async () => {
          try {
            const response = await patchReschedulingDates(id, {
              fechaProbableRealizacion: values.dates.realizationDate,
              fechaNecesidadRespuesta: values.dates.responseDate
            });

            hideModal();
            history.push('/');
            setNewToast({
              type: 'SUCCESS',
              message: response.mensaje
            });
          } catch (err) {
            setNewToast({
              type: 'ERROR',
              message: err.message
            });
            hideModal();
          }
        }}
        primaryActionDisabled={errors?.dates?.realizationDate || errors?.dates?.responseDate}
        primaryActionLabel="Aceptar"
        secondaryAction={hideModal}
        secondaryActionLabel="Salir"
        show={showModal.reprogramar}
        size="md"
        title="Reprogramar solicitud de servicio"
      >
        <>
          <p className="h5">
            Las aceptaciones y/o rechazos informados por los proveedores para la solicitud{' '}
            <strong>N° {sdsNumber}</strong> serán desestimados.
          </p>
          <hr className="mt-4 mb-4" />
          <ReschedulingForm dates={values.dates} errors={errors} setFieldValue={setFieldValue} />
        </>
      </ModalGeneric>

      <ModalGeneric
        backdrop
        infoModal
        onHide={hideModal}
        primaryAction={async () => {
          try {
            setDisableButton(true);
            let response;

            if (isMonthly) {
              response = await putCancelMonthly(id);
            } else {
              response = await putCancel(id);
            }
            history.push('/');
            hideModal();
            setNewToast({
              type: 'ERROR',
              message: response.mensaje
            });
          } catch (err) {
            setDisableButton(false);
            hideModal();
            setNewToast({
              type: 'ERROR',
              message: err.message
            });
          }
        }}
        primaryActionDisabled={disableButton}
        primaryActionLabel="Aceptar"
        secondaryAction={hideModal}
        secondaryActionLabel="Salir"
        show={showModal.cancelar}
        size="md"
        title="Cancelar solicitud de servicio"
        variantHeader="danger"
      >
        <p className="text-center">
          ¿Querés cancelar la solicitud de servicio <strong>N° {sdsNumber}</strong>?
        </p>
      </ModalGeneric>

      <ModalGeneric
        backdrop
        infoModal
        onHide={hideModal}
        primaryAction={async () => {
          try {
            let response;

            if (showModal.rechazar) {
              response = await patchResponseProvider(
                {
                  acepta: false,
                  clasificacionRechazoEnum: values.classification,
                  motivo: values.reason
                },
                id
              );
            }
            if (showModal.cancelarAceptacion) {
              response = await patchResponseProvider(
                {
                  acepta: false,
                  clasificacionRechazoEnum: 1,
                  motivo: values.reason
                },
                id
              );
            }
            hideModal();
            history.push('/');
            setNewToast({
              type: 'ERROR',
              message: response.mensaje
            });
          } catch (err) {
            hideModal();
            setNewToast({
              type: 'ERROR',
              message: err.message
            });
          }
        }}
        primaryActionDisabled={errors?.reason || !touched?.classification}
        primaryActionLabel="Comunicar"
        secondaryAction={hideModal}
        secondaryActionLabel="Salir"
        show={showModal.rechazar || showModal.cancelarAceptacion}
        size="lg"
        title={(() => {
          if (showModal.rechazar) return 'Rechazar';
          if (showModal.cancelarAceptacion) return 'Cancelar aceptación';

          return '';
        })()}
        variantHeader="danger"
      >
        <RejectionForm
          classification={values.classification}
          reason={values.reason}
          sdsNumber={sdsNumber}
          setFieldTouched={setFieldTouched}
          setFieldValue={setFieldValue}
          withClassification={showModal.rechazar}
        />
      </ModalGeneric>
      <ModalGeneric
        backdrop
        infoModal
        onHide={hideModal}
        primaryAction={async () => {
          try {
            setDisableButton(true);
            const response = await patchResponseProvider(
              {
                acepta: true
              },
              id
            );

            history.push('/');
            hideModal();
            setNewToast({
              type: 'SUCCESS',
              message: response.mensaje
            });
          } catch (err) {
            setDisableButton(false);
            setNewToast({
              type: 'ERROR',
              message: err.message
            });
          }
        }}
        primaryActionDisabled={disableButton}
        primaryActionLabel="Aceptar"
        secondaryAction={hideModal}
        secondaryActionLabel="Salir"
        show={showModal.aceptarSolicitud}
        size="md"
        title="Aceptar solicitud de servicio"
      >
        <p className="text-center">
          ¿Querés Aceptar la solicitud de servicio <strong>N° {sdsNumber}</strong>? de{' '}
          <strong>{sdsName}</strong>
        </p>
      </ModalGeneric>
      <ModalGeneric
        backdrop
        infoModal
        onHide={hideModal}
        primaryAction={async () => {
          try {
            let response;
            const body = {
              comentario: null,
              calificacion: null,
              motivoBajaCalificacionEnum: null
            };

            if (isMonthly) {
              response = await putFinalizeServiceMonthly(id, body);
            } else {
              response = await putFinalizeService(id, body);
            }
            hideModal();
            history.push('/');
            setNewToast({
              type: 'SUCCESS',
              message: response.mensaje
            });
          } catch (e) {
            hideModal();
            setNewToast({
              type: 'ERROR',
              message: e.message
            });
          }
        }}
        primaryActionLabel="Aceptar"
        secondaryAction={hideModal}
        secondaryActionLabel="Salir"
        show={showModal.finalizar}
        size="md"
        title="Finalizar servicio"
        variantHeader="danger"
      >
        <p>
          ¿Querés finalizar la solicitud de servicio <strong>N° {sdsNumber}</strong>?
        </p>
      </ModalGeneric>
    </>
  );
};

ButtonTab.propTypes = {
  idStatus: PropTypes.number,
  accepted: PropTypes.bool,
  sdsNumber: PropTypes.string.isRequired,
  sdsName: PropTypes.string.isRequired,
  dates: PropTypes.shape({
    realizationDate: PropTypes.string,
    responseDate: PropTypes.string
  }),
  showFinalizeButton: PropTypes.bool,
  isMonthly: PropTypes.bool
};

ButtonTab.defaultProps = {
  idStatus: 0,
  accepted: false,
  showFinalizeButton: false,
  dates: {
    realizationDate: '',
    responseDate: ''
  },
  isMonthly: false
};

export default ButtonTab;
